const influencers = 
{
  influencer01: 
  {    
    name      : 'Vive en 360',
    username  : 'viveen360'
  },
  influencer02: 
  {    
    name      : 'La Caridad',
    username  : 'lacaridadenquito'
  },
  influencer03: 
  {    
    name      : 'Mela Vásconez',
    username  : 'mela_vasconez'
  },
  influencer04: 
  {    
    name      : 'Alisson Fernandez',
    username  : 'made_in_uio'
  },
};

export default influencers;